import NavMesh from "./navmesh";

export default NavMesh;
